import { useStore } from 'zustand';
var useShopDialogStore = function useShopDialogStore(select) {
  return useStore(window.NikeShop.__INTERNAL_USE__.stores.shopDialog.store, select);
};
export default useShopDialogStore;